export default function(phone) {
  if (!phone) {
    return true;
  }
  return /^(?:\+62|0)(?:8[1-9][0-9]{6,10}|[2-9][0-9]{7,11})$/.test(phone);
}
